import { Link } from "react-router-dom";
import { Car, MapPin, Phone, Clock, ExternalLink } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-primary flex items-center justify-center">
                <Car className="w-6 h-6 text-white" />
              </div>
              <div>
                <span className="font-heading font-bold text-lg tracking-tight">
                  Easy Payments
                </span>
                <span className="block text-xs text-slate-400 uppercase tracking-widest">
                  Auto Sales
                </span>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Affordable weekly car rentals in the Lexington Metropolitan Area. 
              Perfect for delivery drivers and daily work commutes.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold uppercase tracking-wide text-sm mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-slate-400 hover:text-white transition-colors duration-200 text-sm"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/fleet"
                  className="text-slate-400 hover:text-white transition-colors duration-200 text-sm"
                >
                  Our Fleet
                </Link>
              </li>
              <li>
                <a
                  href="https://easypaymentsautosales.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-white transition-colors duration-200 text-sm inline-flex items-center gap-1"
                >
                  Main Website <ExternalLink className="w-3 h-3" />
                </a>
              </li>
            </ul>
          </div>

          {/* Service Area */}
          <div>
            <h4 className="font-heading font-bold uppercase tracking-wide text-sm mb-6">
              Service Area
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-slate-400 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 text-primary flex-shrink-0" />
                <span>Lexington Metropolitan Area</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold uppercase tracking-wide text-sm mb-6">
              Book Your Car
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-slate-400 text-sm">
                <Phone className="w-4 h-4 text-primary flex-shrink-0" />
                <a
                  href="sms:8592703755?body=car%20rental"
                  className="hover:text-white transition-colors duration-200"
                  data-testid="footer-phone"
                >
                  (859) 270-3755
                </a>
              </li>
              <li className="flex items-start gap-2 text-slate-400 text-sm">
                <Clock className="w-4 h-4 mt-0.5 text-primary flex-shrink-0" />
                <span>Text "car rental" to book</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            &copy; {new Date().getFullYear()} Easy Payments Auto Sales. All rights reserved.
          </p>
          <Link
            to="/admin"
            className="text-slate-600 hover:text-slate-400 text-xs uppercase tracking-wide transition-colors duration-200"
            data-testid="footer-admin-link"
          >
            Admin Access
          </Link>
        </div>
      </div>
    </footer>
  );
};
